import REST from '../REST';

export const load = () => (
  REST
    .get('https://status.liquid.com/api/v2/status.json')
    .then(response => {
      return response.status;
    })
    .catch(error => ({
      ...error,
      status: { indicator: '' },
    }))
);



// WEBPACK FOOTER //
// ../src/resources/liquidStatus/index.jsx